export const percentageOf = base => value => {
  if (!base) {
    return 0;
  }

  if (base === value) {
    return 100;
  }

  return Math.round((value / base) * 100);
};

export const roundToSecondDecimal = number => Math.round(number * 100) / 100;
